module.exports = __webpack_public_path__ + "static/wpack/extracted/Google_Translate-minecdbc07953bb9a91f85ecc2e48d1074a.png";